// extracted by mini-css-extract-plugin
export default {"container":"wo-z","heading":"xo-z","text":"yo-z","info":"zo-z","link":"Ao-z","fullMaxWidth":"Bo-z"};